import { getAppLibraryStatus } from "./appLibraryStatus.js";
import { getModeBlockedCategories } from "../domain/modePolicy.js";

/** @typedef {import('../domain/types.js').LockboxAppEntity} LockboxAppEntity */
/** @typedef {import('../domain/types.js').EnforcementPlan} EnforcementPlan */

const MODE_LABELS = {
  normal: "Normal",
  work: "Work",
  sleep: "Sleep",
  strict: "Strict",
};

/**
 * Apps whose genre matches the active mode's `blockedCategories` template but are not restricted yet.
 * Suggestions only — not auto-blocked.
 *
 * @param {{ activeModeId: string, rulepack: import('../domain/types.js').LockboxRulepack }} state
 * @param {LockboxAppEntity[]} libraryApps
 * @param {EnforcementPlan|null} plan
 * @returns {LockboxAppEntity[]}
 */
export function getDistractingAppsForActiveMode(state, libraryApps, plan) {
  const mode = state.activeModeId;
  if (!mode || mode === "normal") return [];

  const targetCats = new Set(getModeBlockedCategories(mode, state.rulepack));
  if (targetCats.size === 0) return [];

  return libraryApps.filter((app) => {
    const cat = app.classification?.primaryCategory || "unknown";
    if (!targetCats.has(cat)) return false;
    const status = getAppLibraryStatus(app, plan, state.rulepack, mode);
    return status.badge === "allowed" || status.badge === "not_in_lockbox";
  });
}

/**
 * @param {string} modeId
 * @returns {string}
 */
export function modeBannerTitle(modeId) {
  const label = MODE_LABELS[modeId] || modeId;
  return `🧠 ${label} Mode is active`;
}
